import { Alert, Card, Table } from 'react-bootstrap';
import { formatMoney, parseFeeConfig, toMoneyNumber } from './eventFeeUtils';

function buildFeeRows(eventItem) {
  const feeConfig = parseFeeConfig(eventItem?.fee_config);
  const baseFee = toMoneyNumber(eventItem?.fee_amount);

  if (eventItem?.registration_count_mode === 'people') {
    const people = feeConfig?.peopleByType || {};
    return [
      { label: 'Adulto', amount: toMoneyNumber(people.adult) ?? baseFee },
      { label: 'Adolescente', amount: toMoneyNumber(people.adolescent) ?? baseFee },
      { label: 'Niño', amount: toMoneyNumber(people.child) ?? baseFee },
    ];
  }

  const membership = feeConfig?.membershipByType || {};
  return [
    { label: 'Matrimonios', amount: toMoneyNumber(membership.matrimonios) ?? baseFee },
    { label: 'Mamás', amount: toMoneyNumber(membership.mamas) ?? baseFee },
    { label: 'Asesor espiritual', amount: toMoneyNumber(membership.asesorEspiritual) ?? baseFee },
  ];
}

function EventFeeDetailsTable({ eventItem, title = 'Detalle de precio' }) {
  if (!eventItem) {
    return null;
  }

  if (eventItem.payment_type === 'free') {
    return <Alert variant="info" className="mb-0">Evento gratuito (sin costo de inscripción).</Alert>;
  }

  const rows = buildFeeRows(eventItem);

  return (
    <Card>
      <Card.Body>
        <h6 className="mb-3">{title}</h6>
        <Table size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Costo</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={`fee-row-${row.label}`}>
                <td>{row.label}</td>
                <td>{formatMoney(row.amount)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default EventFeeDetailsTable;